import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _CreateStudyPlanPanel, _Title, _CategoryChips, _CatalogCourseCards;
import React from "react";
import { CreateStudyPlanPanel } from "./components";
import { CatalogEmptyStateContextProvider } from "./context";
import { CatalogCourseCards, CategoryChips, Title } from "./sections";
import { Container } from "./ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CatalogEmptyState = function CatalogEmptyState(props) {
  var showStudyPlanEmptyState = props.showStudyPlanEmptyState,
    className = props.className;
  return /*#__PURE__*/_jsxs(CatalogEmptyStateContextProvider, _objectSpread(_objectSpread({}, props), {}, {
    children: [showStudyPlanEmptyState && (_CreateStudyPlanPanel || (_CreateStudyPlanPanel = /*#__PURE__*/_jsx(CreateStudyPlanPanel, {}))), /*#__PURE__*/_jsxs(Container, {
      className: className,
      children: [_Title || (_Title = /*#__PURE__*/_jsx(Title, {})), _CategoryChips || (_CategoryChips = /*#__PURE__*/_jsx(CategoryChips, {})), _CatalogCourseCards || (_CatalogCourseCards = /*#__PURE__*/_jsx(CatalogCourseCards, {}))]
    })]
  }));
};
CatalogEmptyState.displayName = 'CatalogEmptyState';
export default CatalogEmptyState;